import GalleryOverlapped from './gallery-overlapped';
import Flickity from "flickity";
import {PageEvent} from '~/pages/page.js';
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import HoverCursorManager from '../../helpers/hover-cursor-manager'

export default class GalleryOverlappedDesktop extends GalleryOverlapped {
    constructor(...args) {
        super(...args);

        this.animated = true;
        this._isDesktop = ( ENV.device == 'desktop' );

        if( this._isDesktop ) {

            this._HoverCursorManager = new HoverCursorManager( {
                container : this.dom.component,
                gallery : {
                    classesName : {
                        items : 'js-gallery-item',
                        icons : 'js-gallery-download-button'
                    }
                }
            } );
        }
    }

    _retrieveDOM() {
        super._retrieveDOM();

        this.dom.animate = {
            background : [].slice.call( this.dom.component.querySelectorAll('.js-anim-background') ),
            mask : this.dom.component.querySelector('.js-anim-mask'),
            text : [].slice.call( this.dom.component.querySelectorAll('.js-anim-text') ),
            gallery : this.dom.component.querySelector('.js-anim-gallery')
        };

        if( this.dom.animate.mask ) {
            this._maskOpacity = parseFloat( this.dom.animate.mask.dataset.opacity );
        }
    }

    init() {
        super.init();

        this._initScrollAnim();
    }

    bind() {
        super.bind();

        if( this.dom.container )
        {
            var flky = new Flickity( this.dom.container, {
                cellAlign: 'left',
                prevNextButtons: true,
                contain: true,
                groupCells: '80%',
                arrowShape: 'M8.293 7.293a1 1 0 0 1 1.414 1.414L5 13.414.293 8.707a1 1 0 1 1 1.414-1.414L5 10.586l3.293-3.293z'
            } );
        }
    }

    _initScrollAnim() {

        if( this._isDesktop )
            this._animBackground();
        this._animContent();
    }

    _animBackground() {

        // Create Tweenmax Animation
        let tweenBackground = new TimelineMax();
        tweenBackground
            .fromTo( this.dom.animate.background, 5, {scale: 1.15}, { scale: 1, ease: Power1.easeOut }, 'init')
        if( this.dom.animate.mask )
            tweenBackground.fromTo( this.dom.animate.mask, 2, {opacity: 0}, { opacity: this._maskOpacity, ease: Power1.easeOut }, 'init+=2')

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.component,
            // tweenChanges: true, // smooth effect
            offset: -window.innerHeight / 2,
            duration: this.dom.component.offsetHeight * 1.7
        });
        // scene.addIndicators();
        scene.setTween( tweenBackground );

        this.emit( PageEvent.ADD_SCENE, scene );
    }

    _animContent() {

        let tweenContent = new TimelineMax();

        if( this.dom.animate.text.length > 0 )
            tweenContent
                .fromTo( this.dom.animate.text, 5,{y:300}, { y: 0, ease: Power4.easeOut }, 'init')
        if( this.dom.animate.gallery )
            tweenContent
                .fromTo( this.dom.animate.gallery, 3,{y:300}, { y: 0, ease: Power4.easeOut }, 'init+=1.5');

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.component,
            // tweenChanges: true, // smooth effect
            // offset: -window.innerHeight / 3,
            duration: this.dom.component.offsetHeight
        });
        // scene.addIndicators();
        scene.setTween( tweenContent );

        this.emit( PageEvent.ADD_SCENE, scene );
    }

    _update( pos ) {

        if( this._isDesktop ) {
            this._HoverCursorManager.update( pos );
        }
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/gallery-overlapped/gallery-overlapped.desktop.js